import React, { useState, useEffect, useCallback } from "react";
import "../AddAnnouncement/AddAnnouncement.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import { Apiurl, GetToken } from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../Components/loader/loader";

const AddAnnouncement = () => {
  const [showSidebar, setShowSidebar] = useState(true);
  const [errorAnnouncementTitle, setErrorAnnouncementTitle] = useState(false);
  const [AnnouncementTitle, setAnnouncementTitle] = useState("");
  const [AnnouncementDate, setAnnouncementDate] = useState("");
  const [AnnouncementDescription, setAnnouncementDescription] = useState("");
  const [AnnouncementDateError, setAnnouncementDateError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [AnnouncementDescriptionError, setAnnouncementDescriptionError] =
    useState(false);
  const [announcementList, setAnnouncementList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [editId, setEditId] = useState(null);
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);

  const AnnouncementToken = GetToken();
  const todayDate = new Date().toISOString().split("T")[0];

  const validate = () => {
    let isValid = true;

    if (!AnnouncementTitle?.trim()) {
      setErrorAnnouncementTitle("userAnnouncementTitle");
      isValid = false;
    } else {
      setErrorAnnouncementTitle("");
    }

    if (!AnnouncementDate) {
      setAnnouncementDateError("userAnnouncementDate");
      isValid = false;
    } else {
      const selectedDate = new Date(AnnouncementDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate < today) {
        setAnnouncementDateError("userAnnouncementDate");
        toast.error("Back date is not allowed.");
        isValid = false;
      } else {
        setAnnouncementDateError("");
      }
    }

    if (!AnnouncementDescription?.trim()) {
      setAnnouncementDescriptionError("userAnnouncementDescription");
      isValid = false;
    } else {
      setAnnouncementDescriptionError("");
    }

    return isValid;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "-";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const toInputDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0];
  };

  const fetchAnnouncements = useCallback(async () => {
    try {
      setTableLoading(true);

      const response = await axios({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${AnnouncementToken}`,
        },
        url: `${Apiurl()}/Announcement/GetAnnouncements`,
      });

      if (response?.status === 200) {
        let parsedAnnouncements = [];

        if (Array.isArray(response?.data?.data)) {
          parsedAnnouncements = response.data.data;
        } else if (typeof response?.data?.data === "string") {
          try {
            parsedAnnouncements = JSON.parse(response.data.data);
          } catch (error) {
            parsedAnnouncements = [];
          }
        }

        setAnnouncementList(
          Array.isArray(parsedAnnouncements) ? parsedAnnouncements : []
        );
      }
    } catch (error) {
      console.log("Fetch announcements error:", error?.response || error);
      setAnnouncementList([]);
      toast.error(
        error?.response?.data?.message ||
          error?.response?.data?.Message ||
          "Failed to load announcements."
      );
    } finally {
      setTableLoading(false);
    }
  }, [AnnouncementToken]);

  const resetForm = () => {
    setAnnouncementTitle("");
    setAnnouncementDate("");
    setAnnouncementDescription("");
    setErrorAnnouncementTitle("");
    setAnnouncementDateError("");
    setAnnouncementDescriptionError("");
    setEditId(null);
  };

  const SaveAnnouncement = async () => {
    if (!validate()) return;

    try {
      setLoading(true);

      const payload = {
        ...(editId ? { Id: Number(editId) } : {}),
        AnnouncementTitle: AnnouncementTitle.trim(),
        Description: AnnouncementDescription.trim(),
        FlashTillDate: AnnouncementDate,
      };

      const requestBody = {
        Data: JSON.stringify(payload),
      };

      console.log("Save request body:", requestBody);

      const response = await axios({
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${AnnouncementToken}`,
        },
        url: `${Apiurl()}/Admin/SaveAnnouncement`,
        data: requestBody,
        validateStatus: () => true,
      });

      console.log("Save response:", response);

      if (response?.status === 200 && (response?.data?.success || response?.data?.Success)) {
        toast.success(
          response?.data?.message ||
            response?.data?.Message ||
            `Announcement ${editId ? "updated" : "saved"} successfully.`
        );
        resetForm();
        fetchAnnouncements();
      } else {
        toast.error(
          response?.data?.message ||
            response?.data?.Message ||
            "Failed to save announcement."
        );
      }
    } catch (err) {
      console.log("Save error:", err?.response || err);
      toast.error(
        err?.response?.data?.message ||
          err?.response?.data?.Message ||
          "Failed to save announcement."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (item) => {
    setEditId(item?.Id);
    setAnnouncementTitle(item?.AnnouncementTitle || "");
    setAnnouncementDate(toInputDate(item?.FlashTillDate));
    setAnnouncementDescription(item?.Description || "");
    setErrorAnnouncementTitle("");
    setAnnouncementDateError("");
    setAnnouncementDescriptionError("");

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDeleteConfirm = (id) => {
    setDeleteConfirmId(id);
  };

  const handleDeleteCancel = () => {
    setDeleteConfirmId(null);
  };

  const handleDelete = async (id) => {
    const numericId = Number(id);

    if (!numericId || Number.isNaN(numericId)) {
      toast.error("Invalid announcement id.");
      console.log("Invalid delete id:", id);
      return;
    }

    try {
      setLoading(true);

      const requestBody = {
        Data: JSON.stringify({ Id: numericId }),
      };

      console.log("Delete clicked Id:", id);
      console.log("Delete numeric Id:", numericId);
      console.log("Delete request body:", requestBody);
      console.log("Delete URL:", `${Apiurl()}/Admin/DeleteAnnouncement`);

      const response = await axios({
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${AnnouncementToken}`,
        },
        url: `${Apiurl()}/Announcement/DeleteAnnouncement`,
        data: requestBody,
        validateStatus: () => true,
      });

      console.log("Delete response status:", response?.status);
      console.log("Delete response data:", response?.data);

      if (response?.status === 200 && (response?.data?.success || response?.data?.Success)) {
        toast.success(
          response?.data?.message ||
            response?.data?.Message ||
            "Announcement deleted successfully."
        );
        setDeleteConfirmId(null);
        fetchAnnouncements();
      } else {
        toast.error(
          response?.data?.message ||
            response?.data?.Message ||
            `Delete failed. Status: ${response?.status}`
        );
      }
    } catch (err) {
      console.log("Delete catch error:", err);
      console.log("Delete catch response:", err?.response);
      console.log("Delete catch data:", err?.response?.data);

      toast.error(
        err?.response?.data?.message ||
          err?.response?.data?.Message ||
          err?.message ||
          "Failed to delete announcement."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancelButton = () => {
    resetForm();
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => setShowSidebar(false), 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  useEffect(() => {
    fetchAnnouncements();
  }, [fetchAnnouncements]);

  return (
    <>
      {loading ? <Loader /> : null}

      {deleteConfirmId && (
        <div className="announcement-modal-overlay">
          <div className="announcement-modal">
            <h5 className="announcement-modal-title">Delete Announcement</h5>
            <p className="announcement-modal-message">
              Are you sure you want to delete this announcement? This action cannot be undone.
            </p>
            <div className="announcement-modal-actions">
              <button
                className="announcement-modal-cancel-btn"
                onClick={handleDeleteCancel}
              >
                Cancel
              </button>
              <button
                className="announcement-modal-delete-btn"
                onClick={() => handleDelete(deleteConfirmId)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

      <div className="d-flex announcement-page-layout">
        <Sidebar showSidebar={showSidebar} />

        <div
          className={
            showSidebar
              ? "main-container-of-all-employees-page-annoucement"
              : "main-container-of-all-employees-page-annoucement-new"
          }
        >
          <div className="inner-container-of-all-employees-page">
            <div className="header-of-employees-page row">
              <div className="all-employee-text-annoucement col">
                <h4>{editId ? "Edit Announcement" : "Add Announcement"}</h4>
              </div>
              <div className="all-employees-directory-annoucement col">
                <div className="home-icon-header-annoucement">
                  <BiHomeAlt />
                </div>
                <div className="arrow-icon-header-annoucement">
                  <MdKeyboardArrowRight />
                </div>
                <div className="employee-text-header-annoucement">
                  <p>Dashboard</p>
                </div>
                <div className="arrow-icon-header-profile">
                  <MdKeyboardArrowRight />
                </div>
                <div className="all-employee-text-header-annoucement">
                  <p>{editId ? "Edit Announcement" : "Add Announcement"}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="main-container-for-security-annoucement">
            <div className="outer-div-of-username-password-annoucement">
              {editId && (
                <div className="announcement-edit-banner">
                  ✏️ Editing announcement — make your changes and click <strong>Submit</strong>.
                </div>
              )}

              <div className="username-password-annoucement">
                <div className="announcement-top-row">
                  <div className="announcement-field announcement-field-no-label">
                    <input
                      type="text"
                      value={AnnouncementTitle}
                      onChange={(e) => setAnnouncementTitle(e.target.value)}
                      placeholder="Announcement Title"
                    />
                    {errorAnnouncementTitle === "userAnnouncementTitle" &&
                      !AnnouncementTitle?.trim() && (
                        <span className="AnnouncementTitle-error">
                          Announcement Title is required.
                        </span>
                      )}
                  </div>

                  <div className="announcement-field">
                    <label>Flash Till Date</label>
                    <input
                      type="date"
                      value={AnnouncementDate}
                      min={todayDate}
                      onChange={(e) => setAnnouncementDate(e.target.value)}
                    />
                    {AnnouncementDateError === "userAnnouncementDate" && !AnnouncementDate && (
                      <span className="AnnouncementTitle-error">
                        Flash Till Date is required.
                      </span>
                    )}
                    {AnnouncementDateError === "userAnnouncementDate" && AnnouncementDate && (
                      <span className="AnnouncementTitle-error">
                        Back date is not allowed.
                      </span>
                    )}
                  </div>
                </div>

                <div className="password-floating-annoucement">
                  <textarea
                    cols="30"
                    rows="8"
                    placeholder="Description"
                    value={AnnouncementDescription}
                    spellCheck={false}
                    autoCorrect="off"
                    autoComplete="off"
                    data-gramm="false"
                    onChange={(e) => setAnnouncementDescription(e.target.value)}
                  ></textarea>

                  {AnnouncementDescriptionError === "userAnnouncementDescription" &&
                    !AnnouncementDescription?.trim() && (
                      <span className="AnnouncementTitle-er">Description is required.</span>
                    )}

                  <div className="save-button-in-setting-annoucement">
                    <button
                      className="save-button-in-setting-annoucement-button-one"
                      onClick={SaveAnnouncement}
                    >
                      {editId ? "Update" : "Submit"}
                    </button>
                    <button
                      onClick={handleCancelButton}
                      className="save-button-in-setting-annoucement-button-two"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="announcement-table-card">
              <div className="announcement-table-header">
                <h5>Announcement List</h5>
              </div>

              <div className="announcement-table-wrapper">
                <table className="announcement-table">
                  <thead>
                    <tr>
                      <th className="announcement-sr-col">Sr.No</th>
                      <th className="announcement-title-col">Announcement Title</th>
                      <th className="announcement-desc-col">Details</th>
                      <th className="announcement-date-col">Flash Till Date</th>
                      <th className="announcement-action-col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {tableLoading ? (
                      <tr>
                        <td colSpan="5" className="announcement-no-data">
                          Loading announcements...
                        </td>
                      </tr>
                    ) : announcementList?.length > 0 ? (
                      announcementList.map((item, index) => (
                        <tr key={item?.Id || index}>
                          <td className="announcement-sr-col">{index + 1}</td>
                          <td className="announcement-title-col">
                            {item?.AnnouncementTitle || "-"}
                          </td>
                          <td className="announcement-desc-col">
                            <div className="announcement-description-content">
                              {item?.Description || "-"}
                            </div>
                          </td>
                          <td className="announcement-date-col">
                            {formatDate(item?.FlashTillDate)}
                          </td>
                          <td className="announcement-action-col">
                            <div className="announcement-action-btns">
                              <button
                                className="announcement-edit-btn"
                                onClick={() => handleEdit(item)}
                                title="Edit"
                              >
                                <FiEdit2 size={15} />
                              </button>
                              <button
                                className="announcement-delete-btn"
                                onClick={() => handleDeleteConfirm(item?.Id)}
                                title="Delete"
                              >
                                <FiTrash2 size={15} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="announcement-no-data">
                          No announcements found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="announcement-mobile-card-list">
                {tableLoading ? (
                  <div className="announcement-mobile-card announcement-no-data-card">
                    Loading announcements...
                  </div>
                ) : announcementList?.length > 0 ? (
                  announcementList.map((item, index) => (
                    <div className="announcement-mobile-card" key={item?.Id || index}>
                      <div className="announcement-mobile-row">
                        <span className="announcement-mobile-label">Sr.No</span>
                        <span className="announcement-mobile-value">{index + 1}</span>
                      </div>
                      <div className="announcement-mobile-row">
                        <span className="announcement-mobile-label">Announcement Title</span>
                        <span className="announcement-mobile-value">
                          {item?.AnnouncementTitle || "-"}
                        </span>
                      </div>
                      <div className="announcement-mobile-row">
                        <span className="announcement-mobile-label">Details</span>
                        <span className="announcement-mobile-value announcement-mobile-description">
                          {item?.Description || "-"}
                        </span>
                      </div>
                      <div className="announcement-mobile-row">
                        <span className="announcement-mobile-label">Flash Till Date</span>
                        <span className="announcement-mobile-value">
                          {formatDate(item?.FlashTillDate)}
                        </span>
                      </div>
                      <div className="announcement-mobile-row">
                        <span className="announcement-mobile-label">Action</span>
                        <div className="announcement-action-btns">
                          <button
                            className="announcement-edit-btn"
                            onClick={() => handleEdit(item)}
                            title="Edit"
                          >
                            <FiEdit2 size={15} />
                          </button>
                          <button
                            className="announcement-delete-btn"
                            onClick={() => handleDeleteConfirm(item?.Id)}
                            title="Delete"
                          >
                            <FiTrash2 size={15} />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="announcement-mobile-card announcement-no-data-card">
                    No announcements found.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddAnnouncement;